import { Button } from '../../components';
import React from 'react';
import { RewardPointDetailsService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchCreditList: any;
  setShowOverlay: any;
  status: any;
}
const RewardPointBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchCreditList,
    setShowOverlay,
    status,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    setShowOverlay(true);
    RewardPointDetailsService.blockDomes({ id, status }).then(() => {
      setBlocked(true);
      setShowOverlay(false);
    });
  };

  return (
    <>
      {!blocked ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            {status === 'blocked' ? 'Block' : 'Unblock'}
          </h2>
          <p>
            Are you sure you want to
            {' '}
            {status === 'blocked' ? 'block' : 'unblock'}
            {' '}
            reward points system for this activity?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Activity
            {' '}
            {status === 'blocked' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchCreditList();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default RewardPointBlocked;
